import React, { Suspense, lazy } from 'react'
import { Routes as AppRoutes, Route } from 'react-router-dom'

import Layout from '../layouts/Layout'
import ProtectedRoute from './ProtectedRoute'
import useRefreshToken from '../hooks/useRefreshToken'

const Tracking = lazy(() => import('../components/pages/Tracking'))
const Orders = lazy(() => import('../components/pages/Download/Download'))
const NotFound = lazy(() => import('../components/pages/NotFound'))
const Expired = lazy(() => import('../components/pages/Expired'))

const Routes = () => {
  useRefreshToken()
  return (
    <AppRoutes>
      <Route element={<Layout />}>
        <Route element={<ProtectedRoute />}>
          <Route
            path=":jwt"
            element={
              <Suspense fallback={<span>⌛ Cargando Despacho...</span>}>
                <Orders />
              </Suspense>
            }
          />
          <Route
            path="/detalle/:jwt/:trackingId"
            element={
              <Suspense fallback={<span>⌛ Cargando Pedidos...</span>}>
                <Tracking />
              </Suspense>
            }
          />
        </Route>
      </Route>
      <Route
        path="/expired"
        element={
          <Suspense
            fallback={<span>⌛ Cargando pagina sesión expirada...</span>}
          >
            <Expired />
          </Suspense>
        }
      />
      <Route
        path="*"
        element={
          <Suspense
            fallback={<span>⌛ Cargando pagina no encontrado</span>}
          >
            <NotFound />
          </Suspense>
        }
      />
    </AppRoutes>
  )
}

export default Routes
